import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  switchWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divider: {
    '& .MuiDivider-root': {
      paddingBlock: 8,
    },
  },
  fieldWrapper: {
    paddingBlock: 8,
  },
  container: {
    paddingBlockStart: 16,
  },
  btn: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBlock: 12,
    '& .MuiButton-root': {
      padding: '6px 36px',
      backgroundColor: theme.palette.custom.main,
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#ec7905',
      },
    },
  },
}))

export default useStyles
